export const setValue = (attr, value) => ({
  type: 'ACTIVITIES_VALUE_SET',
  attr,
  value,
});

export const activitiesSetStarted = value => (dispatch) => {
  dispatch(setValue('started', value));
};
